<template>
  <div>
    <list-page-header />
    <yv-index
      :path="path"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :disabledHeaderActions="true"
      :sortable="sortable"
      :sort-data="sortData"
      :tableActionsComponent="TableActions"
    >
    </yv-index>
  </div>
</template>

<script>
import { YvIndex } from "@/components/Base";
import { service_paths } from "@/constants/Services";
import Header from "./Header";
import TableActions from "./TableActions.vue";
import { DEFAULT_OPTION_ALL } from "../../../constants";

export default {
  name: "ListPage",
  components: { YvIndex, ListPageHeader: Header },
  data() {
    return {
      item: null,
      TableActions,

      path: service_paths.programs,
      sortable: [
        "name",
        "status",
        "total_credit",
        "count_graduation_categories"
      ],
      sortData: {
        currentSort: "id",
        currentSortOrder: "desc"
      },
      formSearch: [
        {
          label: "program.filter_by_name",
          name: "name__~",
          value: "",
          type: "input"
        },
        {
          label: "program.filter_by_status",
          name: "status",
          value: "",
          type: "select",
          options: [
            ...DEFAULT_OPTION_ALL,
            {
              id: "Active",
              name: "common.active"
            },
            {
              id: "Inactive",
              name: "common.inactive"
            }
          ]
        }
      ]
    };
  },
  computed: {
    columns() {
      return {
        name: this.$t("program.col_name"),
        total_credit: this.$t("program.col_total_required_credit"),
        status: this.$t("program.col_status"),
        report_template: "Report template",
        transcript_template: "Transcript template",
        count_graduation_categories: this.$t("program.col_graduation_category")
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
